import { useState } from "react";

export const useCodeVerification = () => {
  const [code, setCode] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const isCodeValid = (code: string): boolean => /^\d{6}$/.test(code);

  const handleCodeChange = (newCode: string) => {
    setCode(newCode);
    if (!isCodeValid(newCode)) {
      setError("Please enter a valid 6-digit numeric code.");
    } else {
      setError(null);
    }
  };

  return {
    code,
    error,
    handleCodeChange,
    isCodeValid
  };
};
